import React from "react"
import "./color.css"

function BackIcon() {
	return (
		<div className="back-icon button-icon2">
			<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
				<title>arrow_back</title>
				<g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Outlined" transform="translate(-614.000000, -3436.000000)">
						<g id="Navigation" transform="translate(100.000000, 3378.000000)">
							<g
								id="Outlined-/-Navigation-/-arrow_back"
								transform="translate(510.000000, 54.000000)"
							>
								<g>
									<polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
									<polygon
										className="color"
										id="🔹-Icon-Color"
										fill="#1D1D1D"
										points="20 11 7.83 11 13.42 5.41 12 4 4 12 12 20 13.41 18.59 7.83 13 20 13"
									></polygon>
								</g>
							</g>
						</g>
					</g>
				</g>
			</svg>
		</div>
	)
}

export default BackIcon
